import DashboardLayout from '@/pages/Layout/DashboardLayout.vue';

import Dashboard from '@/pages/Dashboard.vue';
import UserProfile from '@/pages/UserProfile.vue';
import Profile from '@/pages/UserProfile/UserCard.vue';
import DonorList from '@/pages/List/DonorList.vue';
import DonorSearch from '@/pages/List/DonorSearch.vue';
import MyDonation from '@/pages/List/MyDonation/MyDonation';
import FinderList from '@/pages/List/FinderList.vue';
import RequestList from '@/pages/List/RequestList.vue';
import RequestFeedList from '@/pages/List/RequestFeedList.vue';
import Maps from '@/pages/Maps.vue';
import Notifications from '@/pages/Notifications.vue';
import UpgradeToPRO from '@/pages/UpgradeToPRO.vue';
import FeedBackList from "../pages/List/FeedBackList";

const routes =
  {
    path: '/home',
    name: 'DashboardLayout',
    component: DashboardLayout,
    redirect : '/profile',
    children: [
      /*{
        path: '/dashboard',
        name: 'Dashboard',
        component: Dashboard,
        meta:{
          requiredAuth: true
        }
      },*/

      {
        path: '/be-a-donor',
        name: 'Be A Donor',
        component: UserProfile,
        meta:{
          requiredAuth: true
        }
      },
      {
        path: '/my-donation',
        name: 'My Donation',
        component: MyDonation,
        meta:{
          requiredAuth: true
        }
      },
      {
        path: '/search-donor',
        name: 'Search Donors',
        component: Maps,
        meta:{
          requiredAuth: true
        }
      },

      {
        path: '/user',
        name: 'User Profile',
        component: UserProfile,
        meta:{
          requiredAuth: true
        }
      },
      {
        path: '/profile',
        name: 'Profile',
        component: Profile,
        meta:{
          requiredAuth: true
        }
      },
      {
        path: '/donor-list',
        name: 'Donor List',
        component: DonorList,
        meta:{
          requiredAuth: true,
          adminAuth: true
        }
      },
      {
        path: '/finder-list',
        name: 'Finder List',
        component: FinderList,
        meta:{
          requiredAuth: true,
          adminAuth: true
        }
      },
      {
        path: '/requests-list',
        name: 'Requests List',
        component: RequestList,
        meta:{
          requiredAuth: true,
          adminAuth: true
        }
      },
      {
        path: '/requests-feed',
        name: 'Requests Feed',
        component: RequestFeedList,
        meta:{
          requiredAuth: true
        }
      },
      {
        path: '/feedback-list',
        name: 'FeedBack',
        component: FeedBackList,
        meta:{
          requiredAuth: true
        }
      },

      /*{
        path: '/search-donor-results',
        name: 'searchDonorResult',
        meta: {
          hideFooter: true,
          requiredAuth: true
        },
        component: DonorSearch,

      },*/
      {
        path: '/notifications',
        name: 'Notifications',
        component: Notifications,
        meta:{
          requiredAuth: true
        }
      },
      {
        path: '/upgrade',
        name: 'Upgrade to PRO',
        component: UpgradeToPRO
      }
    ]
  };


export default routes;
